import PropTypes from "prop-types";
import type { CSSProperties } from "react";

type PlaceholderProps = {
  type?: "text" | "image" | "button" | "circle";
  width?: string | number;
  height?: string | number;
  className?: string;
  style?: CSSProperties;
  rows?: number;
  active?: boolean;
};

export function Placeholder({
  type = "text",
  width,
  height,
  className = "",
  style = {},
  rows = 1,
  active = true,
}: PlaceholderProps) {
  const getPlaceholderStyle = () => {
    const baseStyle = {
      width: width || "100%",
      height: height || (type === "text" ? "1em" : type === "button" ? "2.5rem" : "200px"),
    };

    return { ...baseStyle, ...style };
  };

  const getBaseClasses = () => {
    const baseClasses = "relative overflow-hidden bg-gray-200 animate-shimmer";

    const typeClasses = {
      text: "h-4 rounded",
      image: "w-full h-full rounded",
      button: "h-10 min-w-[7rem] rounded",
      circle: "rounded-full",
    };

    return `${baseClasses} ${typeClasses[type]} ${className}`;
  };

  const renderPlaceholder = () => {
    const placeholderStyle = getPlaceholderStyle();
    const placeholderClass = getBaseClasses();

    if (type === "text" && rows > 1) {
      return Array.from({ length: rows }).map((_, index) => (
        <div
          key={`placeholder-row-${index}-${Math.random()}`}
          className={placeholderClass}
          style={{
            ...placeholderStyle,
            marginBottom: index === rows - 1 ? 0 : "0.5em",
          }}
        />
      ));
    }

    return <div className={placeholderClass} style={placeholderStyle} />;
  };

  return active ? renderPlaceholder() : null;
}
